import { Alert, AlertDescription, AlertTitle } from "../../components/ui/Alert";
import { Button } from "../../components/ui/Button";
import {
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../../components/ui/Card";
import { Shield, ArrowLeft } from "lucide-react";

const UnauthorizedPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <div className="mx-auto mb-4 bg-red-100 p-3 rounded-full w-20 h-20 flex items-center justify-center">
                        <Shield className="w-12 h-12 text-red-600" />
                    </div>
                    <CardTitle className="text-4xl font-bold text-gray-900">
                        Access Denied
                    </CardTitle>
                </CardHeader>

                <CardContent>
                    <Alert variant="destructive" className="mb-4">
                        <AlertTitle className="text-xl">
                            Unauthorized Access
                        </AlertTitle>
                        <AlertDescription className="text-lg mt-2">
                            You don't have permission to view this page. Please
                            verify your credentials or contact support if you
                            believe this is an error.
                        </AlertDescription>
                    </Alert>
                </CardContent>

                <CardFooter className="flex justify-center">
                    <Button
                        variant="outline"
                        onClick={() => window.history.back()}
                        className="flex items-center gap-2 text-lg px-6 py-3">
                        <ArrowLeft className="w-5 h-5" />
                        Go Back
                    </Button>
                </CardFooter>
            </Card>
        </div>
    );
};

export default UnauthorizedPage;
